function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { jsx as _jsx } from "react/jsx-runtime";
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CollapsePreferences = /*#__PURE__*/function () {
  function CollapsePreferences(component) {
    _classCallCheck(this, CollapsePreferences);
    this.component = component;
    this.collapsePreferences = JSON.parse(localStorage.getItem('collapsePreferences')) || [];
  }
  return _createClass(CollapsePreferences, [{
    key: "toggleCollapse",
    value: function toggleCollapse() {
      var _this = this;
      var currentlyCollapsed = this.component.state.collapsed;
      this.component.setState({
        collapsed: !currentlyCollapsed
      });
      if (currentlyCollapsed) {
        localStorage.setItem('collapsePreferences', JSON.stringify(this.collapsePreferences.filter(function (name) {
          return name !== _this.component.name;
        })));
      } else {
        var uniqueCollapsePreferences = _toConsumableArray(new Set(this.collapsePreferences.concat([this.component.name])));
        localStorage.setItem('collapsePreferences', JSON.stringify(uniqueCollapsePreferences));
      }
    }
  }, {
    key: "preferenceStoredAsCollapsed",
    value: function preferenceStoredAsCollapsed() {
      return this.collapsePreferences.includes(this.component.name);
    }
  }, {
    key: "renderCollapseIcon",
    value: function renderCollapseIcon() {
      return this.component.state.collapsed ? this.plusIcon() : this.minusIcon();
    }
  }, {
    key: "minusIcon",
    value: function minusIcon() {
      return /*#__PURE__*/_jsx("i", {
        className: "print:!hidden fa-regular fa-square-minus"
      });
    }
  }, {
    key: "plusIcon",
    value: function plusIcon() {
      return /*#__PURE__*/_jsx("i", {
        className: "print:!hidden fa-regular fa-square-plus"
      });
    }
  }]);
}();
export { CollapsePreferences as default };